import { useState } from 'react';
import './CopyButton.css';

interface CopyButtonProps {
    text: string;
    label?: string;
    className?: string;
}

export default function CopyButton({ text, label, className = '' }: CopyButtonProps) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <button
            className={`copy-btn ${copied ? 'copied' : ''} ${className}`}
            onClick={handleCopy}
            title="Copy to clipboard"
        >
            {label && <span className="copy-label">{label}</span>}
            <span className="copy-icon">{copied ? '✓' : '📋'}</span>
        </button>
    );
}
